module.exports = __webpack_public_path__ + "img/icon_map_10_off_110.ae108b9c.png";